<template>
  <sTooltip
    :border="false"
    :disabled="!(unregistred || (manualAdded && item.dateAdd)) "
    placement="bottom"
    popper-class="tooltip">
    <div
      :class="['participant-chip black--text px-3', custom_class, {'unregistred': unregistred } ]">
      {{ unregistred ? $t('Tenders.NotRegistered')
        : manualAdded ? $t('Tenders.ManualAdded')
          : isSubscribed ? $t('Tenders.isSubscribed')
            :'' }}
    </div>
    <template #content>
      <div class="pa-4">
        <span v-if="unregistred"> {{ $t('Tenders.NotRegisteredText') }} </span>
        <template v-else-if="manualAdded">
          <div class="h9-text grey--text text-uppercase">
            {{ $t('Tenders.DateWwhenWasAdded') }}
          </div>
          <div>
            {{ formatDate( item.dateAdd ) }}
          </div>
          <template v-if="item.contactAddFio || item.contactAddEmail">
            <div class="h9-text grey--text text-uppercase">
              {{ $t('Tenders.UserAddedBy') }}
            </div>
            <div>
              {{ item.contactAddFio || item.contactAddEmail }}
            </div>
          </template>
        </template>
      </div>
    </template>
  </sTooltip>
</template>
<script>
import moment from 'moment'
export default {
  name: 'participantChip',
  props: {
    unregistred: Boolean,
    manualAdded: Boolean,
    isSubscribed: Boolean,
    custom_class: String,
    item: Object
  },
  created() {
  },

  methods: {
    formatDate(value) {
      let at = this.$t('Common.at')
      if (value) {
        return moment(value).format('DD MMMM YYYY ' + '[' + at + ']' + ' HH:mm')
      }
    },
  },
}
</script>
<style lang="scss" scoped>

.participant-chip {
  width: min-content;
  height: 24px;

  display: inline-flex;
  align-items: center;

  border-radius: 12px;
  background-color: var(--v-main__green-base);

  font-weight: 400;
  font-size: 11px;
  line-height: 12px;

  white-space: nowrap;

  &.unregistred {
    background-color: #E8E8E8;
    color: black !important;
  }
}
.participant-not-registred {
  max-width: 230px;
}
</style>
<style lang="scss">
//.tooltip .participant-not-registred {
//  max-width: 230px;
//}
</style>
